var s3Bucket = process.env.NODE_ENV === 'development' ? 'dev-viral-tees' : 'viral-tees',
    cloudFrontPrefix = process.env.NODE_ENV === 'development' ? 'dev.' : '',
    s3URL = `https://s3.amazonaws.com/${s3Bucket}/`,
    cloudFrontURL = `https://${cloudFrontPrefix}assets.viralstyle.com/`;

export default {
    template: '#control-box',
    props: ['currentSide'],
    events: {
        'on-prepare-images-draft-loaded': function () {
            this.reInitiateImagesAfterImportDraft();
        },
        'side-changed': function (currentSide) {
            if (this.isSublimationProduct()) {
                var scale = this.$root.designerItems[currentSide].length > 0 ? this.$root.designerItems[currentSide][0].scale : 100;
                $('#slider-image').slider('option', "value", parseInt(scale, 10));
                this.$set('imageScalePercent', parseInt(scale, 10) + '%');
            }
        }
    },
    ready: function () {
        var obj = $('.designer_applet'),
            that = this;

        obj.on('dragenter', function (e) {
            e.stopPropagation();
            e.preventDefault();

            if (e.originalEvent.dataTransfer.files.length === 0) {
                return;
            }

            var wizardIndex = $('#form_wizard_1').bootstrapWizard('currentIndex');
            if (wizardIndex == 0)
                $('#cover').show();
        });
        obj.on('dragover', function (e) {
            e.stopPropagation();
            e.preventDefault();
        });
        obj.on('drop', function (e) {
            var wizardIndex = $('#form_wizard_1').bootstrapWizard('currentIndex');
            if (wizardIndex == 0) {

                $('#cover').hide();
                e.preventDefault();
                var files = e.originalEvent.dataTransfer.files;

                //We need to send dropped files to Server
                that.initiateUpload(files[0]);
            }
        });

        obj.on('dragleave', function (e) {
            e.stopPropagation();
            e.preventDefault();
            if (window.event.pageX == 0 || window.event.pageY == 0)
                $('#cover').hide();
        });

        $('#artwork_modal').on('shown.bs.modal', function () {
            var oldTime = that.$root.lastArtworkFetchTime;
            var timeDiffInMinutes = moment().diff(oldTime, 'minutes');
            if (isNaN(timeDiffInMinutes) || timeDiffInMinutes >= 4) {
                that.fetchArtwork();
            }
        });

        $('#slider-image').slider({
            value: 100,
            min: 10,
            max: 200,
            step: 1,
            start: function (e) {
                var currentSide = that.$root.currentSide;
                $('.view-sublimation-' + currentSide).find('.bleed-area').trigger('mousedown', e);
                $('.view-sublimation-' + currentSide).find('.modelImage').trigger('mousedown', e);
            },
            slide: function (event, ui) {
                event.stopPropagation();
                var currentSide = that.$root.currentSide,
                    sublimationImageObject = $('.view-sublimation-' + currentSide + ' .sublimation-image'),
                    originalScaleFraction = (that.$root.designerItems[currentSide][0].scale || 100) / 100,
                    originalWidth = that.$root.designerItems[currentSide][0].imageData.width,
                    originalHeight = that.$root.designerItems[currentSide][0].imageData.height,
                    originalTop = that.$root.designerItems[currentSide][0].imageData.top,
                    originalLeft = that.$root.designerItems[currentSide][0].imageData.left;

                var fraction = (ui.value / 100),
                    newWidth = (originalWidth / originalScaleFraction) * fraction,
                    newHeight = (originalHeight / originalScaleFraction) * fraction,
                    centerX = originalLeft + (originalWidth / 2),
                    centerY = originalTop + (originalHeight / 2),

                    newX = centerX - (newWidth / 2),
                    newY = centerY - (newHeight / 2);

                that.$set('imageScalePercent', ui.value + '%');
                // that.$root.designerItems[currentSide][0].scale = ui.value;

                $(sublimationImageObject).width(newWidth);
                $(sublimationImageObject).height(newHeight);
                $(sublimationImageObject).css({top: newY, left: newX});
            },
            stop: function (event, ui) {
                $('[class*="view-sublimation"] .bleed-area').trigger('mouseup', false);
                $('[class*="view-sublimation"] .modelImage').trigger('mouseup', false);

                var currentSide = that.$root.currentSide,
                    sublimationImageObject = $('.view-sublimation-' + currentSide + ' .sublimation-image'),
                    height = $(sublimationImageObject).height(),
                    width = $(sublimationImageObject).width(),
                    left = parseInt($(sublimationImageObject).css('left'), 10) || 0,
                    top = parseInt($(sublimationImageObject).css('top'), 10) || 0;

                that.$root.designerItems[currentSide][0].scale = ui.value;

                that.$root.designerItems[currentSide][0].span.height = height;
                that.$root.designerItems[currentSide][0].span.width = width;
                that.$root.designerItems[currentSide][0].span.top = top;
                that.$root.designerItems[currentSide][0].span.left = left;

                that.$root.designerItems[currentSide][0].imageData.height = height;
                that.$root.designerItems[currentSide][0].imageData.width = width;
                that.$root.designerItems[currentSide][0].imageData.top = top;
                that.$root.designerItems[currentSide][0].imageData.left = left;
            }
        });

        if (!(that.isCreateSimilar() || that.isDraft()))
            that.openChooseProductModal();
    },
    data: function () {
        return {
            artwork__term: '',
            icons: [],
            isSearching: false,
            imageScalePercent: '100%'
        };
    },
    methods: {
        async addText() {
            var obj = {
                type: 'TEXT',
                span: {
                    width: '0',
                    height: '0',
                    index: -1,
                    autoScaleWidth: 0,
                    autoScaleHeight: 0,
                    left: '0',
                    top: '0',
                    rotLeft: 0,
                    rotTop: 0
                },
                element: {
                    fill: '#000000',
                    stroke: "#000000",
                    stroke_width: "0",
                    stroke_linecap: "round",
                    stroke_linejoin: "round",
                    x: null,
                    y: 30,
                    text_anchor: "middle",
                    font_size: "35px",
                    font_family: "Exo",
                    font_url: []
                },
                svg: {
                    width: '0',
                    height: '0'
                },
                text_block: {
                    font_style: '',
                    font_weight: '',
                    text_decoration: '',
                    alignment_percent: '50%'
                },
                value: 'Viralstyle',
                allow_delete: true,
                rotate: 0
            };

            obj.element.font_url = this.$root.getFontURLByName(obj.element.font_family);

            await this.$nextTickPromise();

            this.$root.addElementToDesigner(obj);
        },
        submitUpload: function () {
            var fileObj = document.getElementById("files-upload").files[0];
            this.initiateUpload(fileObj);
        },
        initiateUpload: function (fileObj) {
            if (fileObj) {
                helpers.showProcessing(true, {
                    boxed: true,
                    message: 'Processing your image. Please wait....'
                });

                var ext = fileObj.name.match(/\.([^\.]+)$/)[1];

                if ($.inArray(ext, (this.isNonMovableDesignProduct ? ['JPG', 'JPEG', 'jpg', 'jpeg', 'png', 'PNG'] : ['png', 'jpg', 'jpeg', 'eps', 'PNG', 'JPG', 'JPEG', 'EPS'])) > -1) {
                    var formData = new FormData();
                    formData.append('image_file', fileObj);
                    formData.append('extension', ext);
                    formData.append('width', this.getImageUploadWidth());
                    formData.append('identifier', this.$root.campaignData.imageIdentifier);
                    formData.append('campaign_identifier', this.$root.campaignData.campaignUniqueId);
                    formData.append('sublimation', this.$root.isSublimationProduct() === true ? 1 : 0);
                    formData.append('is_phone_case', this.$root.isPhoneCaseProduct() === true ? 1 : 0);
                    formData.append('is_embroidery', this.$root.isEmbroideryProduct() === true ? 1 : 0);
                    formData.append('product_id', this.$root.selectedProduct.product.id);
                    formData.append('is_api_order', this.$root.isAPIOrder() === true ? 1 : 0);

                    if (this.getQueryString('no-limit') == null && fileObj.size > 10485760) {
                        helpers.hideProcessing(true);
                        helpers.alert('The size of the file being uploaded cannot be larger than 10MB');
                        return false;
                    }

                    var that = this;
                    Vue.http.post(that.$root.getRequestService().ajaxBase + 'upload-asset', formData).then(async function (response) {
                        var rep = response.data;
                        helpers.hideProcessing(true);
                        var status = rep.status;
                        if (status == 'SUCCESS') {
                            var imageData = rep.data;
                            var colors = imageData.colors,
                                colorCount = imageData.colors_count;
                            if (that.isSublimationProduct() === false) {
                                // Adding Hash to Color Codes as the Color Count service returns without them.
                                // Required for Color Count check as they are grouped by the hex codes with #
                                imageData.colors = _.map(imageData.colors, function (color) {
                                    return '#' + color;
                                });

                                if (colorCount == "FULL_COLOR") {
                                    if (imageData.colors.length < 10) {
                                        var totalColorsToGenerate = 10 - imageData.colors.length,
                                            generatedColors = that.getRandomColorsByCount(totalColorsToGenerate);
                                        _.each(generatedColors, function (color) {
                                            imageData.colors.push(color);
                                        });
                                    }
                                    imageData.colors = _.take(imageData.colors, 10);
                                }
                            }

                            await that.addImage(imageData, false);

                            if (that.isMask) {
                              that.$root.$set('currentSide', that.$root.currentSide === 'front' ? 'back' : 'front');

                              await that.addImage(imageData, false);

                              that.$root.$set('currentSide', that.$root.currentSide === 'front' ? 'back' : 'front');
                            }

                            that.$root.$set('campaignData.imageIdentifier', imageData.identifier);
                            that.$root.$set('campaignData.campaignUniqueId', imageData.campaign_identifier);
                        } else {
                            if (rep.message == "") {
                                helpers.alert('There was an error uploading the image. Please retry again');
                            } else {
                                helpers.alert(rep.message);
                            }
                        }

                        that.clearFileField();
                    }, function (rep) {
                        var data = rep.data;
                        if (data.message)
                            helpers.alert(data.message);
                        else
                            helpers.alert('There was an error processing the image. Please retry again');
                        helpers.hideProcessing(true);

                        that.clearFileField();
                    });
                } else {
                    helpers.hideProcessing(true);
                    if (this.isNonMovableDesignProduct) {
                        helpers.alert(`The File that you have selected isn't an allowed image format for ${this.$root.selectedProduct.product.product_type}. <br/> Allowed Formats - png, jpg`);
                    } else {
                        helpers.alert('The File that you have selected isn\'t an allowed file format. <br/> Allowed Formats - png, jpg, eps ');
                    }
                    this.clearFileField();
                }
            }
        },
        getQueryString ( field, url ) {
            var href = url ? url : window.location.href;
            var reg = new RegExp( '[?&]' + field + '=([^&#]*)', 'i' );
            var string = reg.exec(href);
            return string ? string[1] : null;
        },
        getRandomColorsByCount(count){
            var colors = [],
                i = 0;
            while (i < count) {
                var color = '#' + Math.floor(Math.random() * 16777215).toString(16);
                var checkContainsColor = _.contains(colors, color);
                if (checkContainsColor == false) {
                    colors.push(color);
                    i++;
                }
            }
            return colors;
        },
        getImageUploadWidth: function () {
            if (this.isSublimationProduct()) {
                //Setting the Default Image width to be the size of the Design Area
                return 530 * 2;
            } else {
                var selectedProduct = this.$root.selectedProduct,
                    currentSide = this.$root.currentSide;
                return currentSide == 'front' ? selectedProduct.product.front_width : selectedProduct.product.back_width
            }
        },
        clearFileField: function () {
            //Reset the File element so that if the user tries to upload the same file it allows it
            var fileElement = $('#files-upload');
            fileElement.wrap('<form>').closest('form').get(0).reset();
            fileElement.unwrap();
        },
        openChooseProductModal: function () {
            this.$dispatch('on-open-select-product');
        },
        openDesignTemplatesModal: function () {
            $('#product-templates').modal({
                backdrop: 'static',
                keyboard: false,
                show: true
            })
        },
        uploadFile: function () {
            var html = "";
            if (this.$root.isAPIOrder() === true) {
                if (this.isNonMovableDesignProduct == false) {
                    html = "When uploading your image to Shopify products <b>NOTE</b>:<br><br>" +
                        "<ul>" +
                        "<li>Your image will be printed in the same quality you've uploaded</li>" +
                        "<li>Avoid pixelated or stretched artwork/files</li>" +
                        "<li>Vector files are recommended</li>" +
                        "<li>Viralstyle will not Optimize or Enhance your image before print</li>" +
                        "<li>When uploading PNG or JPG files, be sure have the files generated to at least 200dpi for better results</li>" +
                        "</ul>";
                }
            }

            if (this.isNonMovableDesignProduct) {
                html = "When uploading your <b>" + this.toTitleCase(this.$root.selectedProduct.product.product_type) + "</b> design you won’t be able " +
                    "to adjust the size and location of your image. Please use our design templates " +
                    "to create or adjust your design.<br><br>" +
                    "AVOID THE FOLLOWING: <br>" +
                    "<ul>" +
                    "<li>Stretched or Low resolution images</li>" +
                    "<li>Images without the required Side/Wrap/Bleed area</li>" +
                    "<li>Files larger than 10Mb in size</li>" +
                    "<li>Uploading .EPS vector files (Only JPEG & PNG file formats)</li>" +
                    "</ul><br>" +

                    "<b>How To Videos: </b><br>" +
                    "<ul>" +
                    "<li><a href='https://www.youtube.com/watch?v=fSgj_I5Bzd0' target='_blank'>How To Use Viralstyle's Design Template on Adobe Photoshop</a></li>" +
                    "</ul>";

                html += "Please refer to Viralstyle’s User Agreement for campaign launching terms and Intellectual property stipulations.";
            }

            if (html !== "")
                helpers.alert(html, function () {
                    $('#files-upload').trigger('click');
                });
            else
                $('#files-upload').trigger('click');
        },
        toTitleCase(value){
            return value.replace(/\w\S*/g, function(txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
        },
        getScaleDimensions: function (imageData) {
            var selectedProduct = this.$root.selectedProduct,
                currentSide = this.$root.currentSide,
                imageWidth = imageData.width,
                imageHeight = imageData.height,
                canvasWidth = currentSide == 'front' ? selectedProduct.product.front_width : selectedProduct.product.back_width,
                canvasHeight = currentSide == 'front' ? selectedProduct.product.front_height : selectedProduct.product.back_height;

            canvasWidth -= (this.isNonMovableDesignProduct) ? 0 : 10;
            canvasHeight -= (this.isNonMovableDesignProduct) ? 0 : 10;

            var canvasRatio = canvasHeight / canvasWidth,  // 0.666667
                imageRatio = imageHeight / imageWidth, // 1.2
                reduction = 1;

            if (imageRatio >= canvasRatio) {  // if true match height
                if (imageHeight > canvasHeight) {
                    reduction = canvasHeight / imageHeight; // 0.4
                }
                imageHeight = imageHeight * reduction;
                imageWidth = imageWidth * reduction;
            } else {  // match width
                if (imageWidth > canvasWidth) {
                    reduction = canvasWidth / imageWidth;
                }
                imageWidth = imageWidth * reduction;
                imageHeight = imageHeight * reduction;
            }

            return {width: imageWidth, height: imageHeight};
        },
        reInitiateItemsIntoVueAfterImport(){
            var sides = ['front', 'back'],
                self = this;

            _.each(sides, function (side) {
                var mainProductItemBySide = self.$root.campaignData.mainProduct[side];
                self.$root.designerItems[side] = mainProductItemBySide.designerItems;
            });
        },
        reInitiateImagesAfterImportDraft(){
            var sides = ['front', 'back'],
                self = this;

            this.reInitiateItemsIntoVueAfterImport();

            _.each(sides, function (side) {
                var itemsBySide = self.$root.designerItems[side];
                _.each(itemsBySide, function (item) {
                    if (item.type === 'IMAGE') {
                        self.convertFileToDataURLviaFileReader(item.imageData.original_url, function (encodedURL) {
                            item.imageData.original_encoded = encodedURL;
                            self.convertFileToDataURLviaFileReader(item.imageData.thumbnail_url, function (encoded) {
                                item.imageData.thumbnail_encoded = encoded;
                            });
                        });
                    }
                });
            });
        },
        addImage: function (imageData, isSVG) {
            return new Promise((resolve, reject) => {
                var scale = this.getScaleDimensions(imageData),
                    self = this,
                    originalEncoded = "",
                    thumbnailEncoded = "";

                self.convertFileToDataURLviaFileReader(self.transformCloudFrontToS3(imageData.trimmed_image), function (encodedURL) {
                    originalEncoded = encodedURL;

                    var obj = {
                        type: 'IMAGE',
                        value: self.transformCloudFrontToS3(imageData.resized_image),
                        imageData: {
                            original_url: self.transformCloudFrontToS3(imageData.trimmed_image),
                            original_encoded: originalEncoded,
                            thumbnail_url: self.transformCloudFrontToS3(imageData.trimmed_image),
                            thumbnail_encoded: originalEncoded,
                            original_upload_url: imageData.original_file,
                            height: (self.isSublimationProduct() == 0 || self.isNonMovableDesignProduct) ? scale.height : 630,
                            width: (self.isSublimationProduct() == 0 || self.isNonMovableDesignProduct) ? scale.width : parseFloat(parseFloat((imageData.width / imageData.height) * 630).toFixed(2)),
                            left: 0,
                            top: 0
                        },
                        colors: imageData.colors,
                        allow_delete: true,
                        span: {
                            height: (self.isSublimationProduct() == 0 || self.isNonMovableDesignProduct) ? scale.height : 630,
                            width: (self.isSublimationProduct() == 0 || self.isNonMovableDesignProduct) ? scale.width : parseFloat(parseFloat((imageData.width / imageData.height) * 630).toFixed(2)),
                            top: self.isSublimationProduct() == 1 ? 0 : 5,
                            left: self.isSublimationProduct() == 1 ? 0 : 5,
                            rotLeft: 0,
                            rotTop: 0
                        },
                        element: {
                            x: null,
                            y: 30
                        },
                        rotate: 0
                    };

                    var height = parseFloat(obj.span.height),
                        width = parseFloat(obj.span.width),
                        currentSide = self.$root.currentSide,
                        ph = parseFloat(self.$root.selectedProduct.dimensions[currentSide].offsets.height),
                        pw = parseFloat(self.$root.selectedProduct.dimensions[currentSide].offsets.width),
                        pt = parseFloat(self.$root.selectedProduct.dimensions[currentSide].offsets.top),
                        pl = parseFloat(self.$root.selectedProduct.dimensions[currentSide].offsets.left),
                        top = (ph - height) / 2,
                        left = (pw - width) / 2;

                    if (self.isSublimationProduct() == 0 || (self.isSublimationProduct() && self.isNonMovableDesignProduct)) {
                        obj.span.top = self.isNonMovableDesignProduct ? pt + top : top;
                        obj.span.left = self.isNonMovableDesignProduct ? pl + left : left;

                        obj.imageData.top = self.isNonMovableDesignProduct ? pt + top : top;
                        obj.imageData.left = self.isNonMovableDesignProduct ? pl + left : left;
                    } else {
                        //Centering Design for Sublimation Products and not position to 0,0
                        obj.span.top = top;
                        obj.span.left = left;

                        obj.imageData.top = top;
                        obj.imageData.left = left;
                        obj['scale'] = 100;
                    }

                    self.$root.$set('campaignData.imageIdentifier', imageData.identifier);
                    self.$root.addElementToDesigner(obj);

                    resolve();
                });
            });
        },
        getCanvasTop(imageHeight, areaHeight){
            return ((parseFloat(areaHeight) - parseFloat(imageHeight)) / 2);
        },
        getCanvasLeft(imageWidth, areaWidth){
            return ((parseFloat(areaWidth) - parseFloat(imageWidth)) / 2);
        },
        openArtworkModal: function () {
            var that = this;
            $('#artwork_modal').modal({
                backdrop: 'static',
                keyboard: false,
                show: true
            });
        },
        fetchArtwork: function () {
            var that = this;
            this.isSearching = true;
            Vue.http.post(that.$root.getRequestService().ajaxBase + 'search-artwork', {term: this.artwork_search_term}).then(function (response) {
                var res = response.data;
                that.icons = [];
                that.icons = res;
                that.isSearching = false;
                that.$root.lastArtworkFetchTime = moment();
            });
        },
        addArtwork: function (icon) {
            var url = base64.encode(icon.url),
                currentSide = this.$root.currentSide,
                selectedProduct = this.$root.selectedProduct,
                obj = {
                    id: icon.id,
                    url: url,
                    width: (currentSide == 'front' ? selectedProduct.product.front_width : selectedProduct.product.back_width),
                    campaign_unique_identifier: this.$root.campaignData.campaignUniqueId
                },
                that = this;
            $('#artwork_modal').modal('hide');

            helpers.showProcessing(true);

            Vue.http.post(that.$root.getRequestService().ajaxBase + 'fetch-artwork', obj).then(function (response) {
                var res = response.data;
                if (res.status == "SUCCESS") {
                    var imageData = res.data,
                        svgTemp = $('#svgTemp');

                    $(svgTemp).empty().html(imageData.content);

                    $(svgTemp).find('svg').find('svg,g,path,polygon,rect,circle,ellipse,line,polyline').removeAttr('fill');
                    $(svgTemp).find('svg').find('title,desc').remove();

                    that.$root.unSelectAllControls();

                    var switch_exists = $(svgTemp).find('switch');
                    if (switch_exists.length > 0) {
                        $(svgTemp).find("foreignObject").remove();
                        $(svgTemp).find('g:eq(0)').unwrap();
                    }

                    var processedSVG = that.$root.processSVGToRemoveWhitespace($(svgTemp).find('svg')[0]);

                    var width = processedSVG.width,
                        height = processedSVG.height,
                        processedContent = processedSVG.svg;

                    that.$root.$set('campaignData.campaignUniqueId', imageData.campaign_identifier);

                    var content = $('<div/>').append(processedContent).html();

                    var obj = {
                        type: 'ARTWORK',
                        value: content,
                        imageData: {
                            original_url: imageData.url,
                            name: icon.name
                        },
                        colors: imageData.colors,
                        allow_delete: true,
                        span: {
                            width: width,
                            height: height,
                            top: 5,
                            left: 5,
                            rotLeft: 0,
                            rotTop: 0
                        },
                        element: {
                            fill: '#000000',
                            x: 0,
                            y: 0
                        },
                        svg: {
                            //viewBox: viewBox
                        },
                        rotate: 0
                    };

                    that.$root.addElementToDesigner(obj);
                } else {
                    helpers.alert(res.message);
                }
                helpers.hideProcessing();
            }, function () {
                helpers.alert('There was an error processing the request. Please retry again');
                helpers.hideProcessing(true);
            });
        },
        isSublimationProduct: function () {
            return this.$root.isSublimationProduct();
        },
        clearBackground: function () {
            $('#slider-image').slider('option', 'value', 100);
            this.$set('imageScalePercent', 100 + '%');

            if (this.isMask) {
                this.$root.designerItems['front'].splice(0, 1);
                this.$root.designerItems['back'].splice(0, 1);
            } else {
                this.$root.designerItems[this.currentSide].splice(0, 1);
            }
        },
        showSublimationSettings: function () {

        },
        isPhoneCase: function () {
            return this.$root.isPhoneCaseProduct();
        },
        showSublimationHelp: function () {
            $('#sublimation_help').modal('show');
        },
        artworkEnabled: function() {
            return this.$root.artworkEnabled();
        },
        isEmbroideryProduct: function () {
            return this.$root.isEmbroideryProduct();
        },
        isCreateSimilar(){
            return this.$root.isCreateSimilar();
        },
        isDraft(){
            return this.$root.isCreateSimilar();
        },
        transformCloudFrontToS3(cloudFrontImageURL){
            return cloudFrontImageURL.replace(cloudFrontURL, s3URL);
        },
        convertFileToDataURLviaFileReader(url, callback) {
            var xhr = new XMLHttpRequest();
            xhr.responseType = 'blob';
            xhr.onload = function () {
                var reader = new FileReader();
                reader.onloadend = function () {
                    callback(reader.result);
                }
                reader.readAsDataURL(xhr.response);
            };
            xhr.open('GET', url);
            xhr.send();
        }
    },
    computed: {
        showSublimationControls: function () {
            if (this.$root.selectedProduct)
                return (this.$root.designerItems[this.currentSide].length > 0 && this.$root.selectedProduct.product.sublimation == 1);
        },
        sublimationImageWidth: function () {
            if (this.$root.designerItems[this.currentSide].length > 0)
                return this.$root.designerItems[this.currentSide][0].span.width + 'px';
        },
        sublimationImageHeight: function () {
            if (this.$root.designerItems[this.currentSide].length > 0)
                return this.$root.designerItems[this.currentSide][0].span.height + 'px';
        },
        showEmbroideryControls: function () {
            if (this.$root.selectedProduct)
                return (this.$root.designerItems[this.currentSide].length > 0 && this.$root.selectedProduct.product.is_embroidery == 1);
        },
        isCanvas: function () {
            if (this.$root.selectedProduct)
                return this.$root.selectedProduct.product.render_type === 'CANVAS';

            return false;
        },
        isMats: function () {
            if (this.$root.selectedProduct)
                return this.$root.selectedProduct.product.product_type === 'MATS';

            return false;
        },
        isTowels: function () {
            if (this.$root.selectedProduct)
                return this.$root.selectedProduct.product.product_type === 'TOWELS';

            return false;
        },
        isFlag: function() {
          if (this.$root.selectedProduct) {
            return this.$root.selectedProduct.product.product_type === 'FLAG';
          }

          return false;
        },
        isPoster: function () {
            if (this.$root.selectedProduct)
                return this.$root.selectedProduct.product.product_type === 'POSTER';

            return false;
        },
        isMask: function() {
            if (this.$root.selectedProduct) {
              return this.$root.selectedProduct.product.product_type === 'MASK';
            }

            return false;
        },
        isNonMovableDesignProduct: function () {
            return (this.isCanvas || this.isMats || this.isTowels || this.isFlag || this.isPoster || this.isMask);
        }
    }
};


// WEBPACK FOOTER //
// ./app/assets/js/client-admin/designer/components/designer_tab/controls/controlBox.js